import { ErrorHandler, inject, Injectable } from "@angular/core";
import { LoggerService, PopupService } from "@shared/index";

@Injectable({
    providedIn:'root'
})
export class GlobalErrorHandler implements ErrorHandler{
    private logger=inject(LoggerService);
    private popup=inject(PopupService);
    handleError(error: any): void {
        console.log(error.error.detail);
        
        const message=error.error.detail ? error.error.detail : error.message;
        const stack=error.stack ? error.stack : '';

        // log to console (in dev) or server (in prod)
        this.logger.logError(message,stack);

        console.log('Application Error :',error);

        this.popup.error(message,'');

    }
    
}